// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "umd/" + chunkId + "." + "455dfa45" + ".css";
};